import { createBrowserRouter } from "react-router-dom";
import { Layout } from "@/Layout";
import { AdminAnalyticsPage } from "@/pages/AdminAnalyticsPage";
import { AdminStatsPage } from "@/pages/AdminStatsPage";
import { AdminUsersPage } from "@/pages/AdminUsersPage";
import { ExitPage } from "@/pages/ExitPage";
import { FavoritesPage } from "@/pages/FavoritesPage";
import { LandingPage } from "@/pages/LandingPage";
import { LoginPage } from "@/pages/LoginPage";
import { PostDetailPage } from "@/pages/PostDetailPage";
import { RegisterPage } from "@/pages/RegisterPage";
import { SavedSearchesPage } from "@/pages/SavedSearchesPage";
import { SearchPage } from "@/pages/SearchPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { SyntaxHelpPage } from "@/pages/SyntaxHelpPage";

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: <LandingPage /> },
      { path: "/search", element: <SearchPage /> },
      { path: "/posts/:id", element: <PostDetailPage /> },
      { path: "/favorites", element: <FavoritesPage /> },
      { path: "/saved-searches", element: <SavedSearchesPage /> },
      { path: "/settings", element: <SettingsPage /> },
      { path: "/syntax-help", element: <SyntaxHelpPage /> },
      { path: "/login", element: <LoginPage /> },
      { path: "/register", element: <RegisterPage /> },
      { path: "/exit", element: <ExitPage /> },
      { path: "/admin/analytics", element: <AdminAnalyticsPage /> },
      { path: "/admin/stats", element: <AdminStatsPage /> },
      { path: "/admin/users", element: <AdminUsersPage /> },
    ],
  },
]);
